import React, { HTMLAttributes } from 'react';
import { LocationTypes } from '../../../../sections/sitewide/components/locationMap/locationTypes';
import { TLazyIconKey } from '../../../../utilities/iconLoader/FontAwesomeIcon';
export namespace JumbotronTypes {
  export type TColorTheme = {
    unitStartingPrice?: TColorType;
    priceText?: TColorType;
    selectCardLabel?: TColorType;
  };
  export type TJumbotronContext = {
    locationData: TContactDetails[];
    selectedLocation: TContactDetails;
    variantType: string;
    jumbotron_subtitle: any;
  };

  export type TColorType = 'primary' | 'secondary' | 'accent' | string;
  export type TVariantType = 'single' | 'multi';
  export type TVariant =
    | 'singleLocation'
    | 'singleLocationWithMap'
    | 'multiLocationListOfCard'
    | 'multiLocationDropDown'
    | 'multiLocation'
    | 'hero-section-1'
    | 'hero-section-2'
    | 'hero-section-3';
  export interface IJumbotron extends HTMLAttributes<HTMLDivElement> {
    variant: TVariant;
    contactDetails: TContactDetails[];
    media: TMedia;
    textOverlay?: TTextOverlay;
    locationMapConfig: LocationTypes.ILocationMap;
    headHeight: any;
    cardDropDown?: TCardDropDown;
    accordion: IAccordion;
    locationDetails?: any;
    jumbotron_subtitle?: any;
    cardSectionImages?: any;
  }
  export type TJumbotronTitleLocationSingle = {
    contactDetails: TContactDetails[];
    isImage: any;
  };
  export type TImageURL = {
    isImage: any;
  };
  export type TJumbotronTitleLocationMulti = {
    selectedLocation: TContactDetails;
    isImage: any;
    locationData: TContactDetails[];
    dropDownState: boolean;
    onDropDownButton: () => void;
    selectItemFromDropDown: (selectedLocation: any) => void;
  };

  export interface IHour extends HTMLAttributes<HTMLDivElement> {
    facilityHours?: TFacilityHours;
    className?: string;
  }

  export interface PopOverFacilityhours extends HTMLAttributes<HTMLDivElement> {
    handleMouseOver: () => void;
    handleMouseOut: () => void;
  }
  export interface IBackgroundHeroSection
    extends HTMLAttributes<HTMLDivElement> {
    media?: TMedia;
    className?: string;
    locationMapConfig: LocationTypes.ILocationMap;
    headHeight: any;
    variant: TVariant;
    sectionHeader?: any;
    setShowModalMapLocation?: () => void;
  }
  export interface IBackground extends HTMLAttributes<HTMLDivElement> {
    media: TMedia;
    className?: string;
    locationMapConfig: LocationTypes.ILocationMap;
    headHeight: any;
    variant: TVariant;
    contactDetails: JumbotronTypes.TContactDetails[];
    setLocationData: React.Dispatch<
      React.SetStateAction<JumbotronTypes.TContactDetails[]>
    >;
    setSelectedLocation: React.Dispatch<any>;
    width: number;
  }

  export interface ICTA extends HTMLAttributes<HTMLDivElement> {
    buttonText?: TButtonText[];
    className?: string;
    variant: TVariant;
  }

  export interface IAccordion extends HTMLAttributes<HTMLDivElement> {
    title?: string;
    content: any;
    className?: string;
    closeIcon: TIconSection;
    openIcon: TIconSection;
    variant?: TVariant;
    isActive?: boolean;
  }

  export type TCardDropDown = {
    header: {
      data: string;
      icon: TIconSection;
    };
    cardInputLabel: string;
  };
  export interface ICard extends HTMLAttributes<HTMLDivElement> {
    textOverlay?: TTextOverlay;
    cardDropDown?: TCardDropDown;
    contactDetails?: TContactDetails[];
    theme?: TColorTheme;
    variant: TVariant;
    accordion?: IAccordion;
    cardWidth?: number;
    cardHeight?: number;
  }
  export interface ICarousel extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    children?: any;
    width?: string | number;
  }

  export interface IPrice extends HTMLAttributes<HTMLDivElement> {
    priceSection?: TPriceSection;
    theme?: TColorTheme;
    variant: TVariant;
  }

  export type TPriceSection = {
    icon: TIconSection;
    text: string;
    price: {
      icon: TIconSection;
      unitStartingPrice: number;
    };
  };

  // export type TDaywiseHours = {
  //   label?: string;
  //   data?: string;
  // };

  export type TLocationType = 'single' | 'multi';
  export type TLocations = {
    variantType: TLocationType;
  };
  export type TFormattedFacilityHours = {
    officeHrs: string[];
    gateHrs: string[];
  };

  export interface CardFormattedHrs extends HTMLAttributes<HTMLDivElement> {
    onFacilityHrsToggle: () => void;
    formattedHrs: TFormattedFacilityHours;
    hideToggle?: boolean;
    show?: 'facilityHrsOnly' | 'gateHrsOnly' | 'both';
  }

  export type TCustomHours = {
    sunday: TOpenCloseHrs;
    monday: TOpenCloseHrs;
    tuesday: TOpenCloseHrs;
    wednesday: TOpenCloseHrs;
    thursday: TOpenCloseHrs;
    friday: TOpenCloseHrs;
    saturday: TOpenCloseHrs;
  };

  export type TOpenCloseHrs = {
    open: string;
    close: string;
  };

  export type TDaywiseHours = {
    allDays?: TOpenCloseHrs;
    weekends?: TOpenCloseHrs;
    weekdays?: TOpenCloseHrs;
    customDays?: TCustomHours;
  };

  export type TFacilityHours = {
    officeHrs: TDaywiseHours;
    gateHrs: TDaywiseHours;
  };

  export type TContactDetails = {
    facilityName: string;
    locationName: string;
    address: TAddress[];
    contactNumber?: TContactNumber[];
    emailAddress?: TEmailAddress[];
    reviewRating: LocationTypes.IRating;
    reviewLink?: TReviewLink;
    priceSection: TPriceSection;
    facilityHours: TFacilityHours;
    buttonText?: TButtonText[];
    addressText: string;
  };

  export type TReviewLink = {
    text: string;
    link: string;
    color: string;
  };

  export type TAddress = {
    icon?: TIconSection;
    label: string;
    data: string;
    link: string;
  };

  export type TContactNumber = {
    icon?: TIconSection;
    label?: string;
    data?: number;
    link?: string;
  };

  export type TEmailAddress = {
    icon: TIconSection;
    label: string;
    data: string;
    link: string;
  };

  export type TTextOverlay = {
    title?: string;
    subTitle?: string;
  };

  export type TIconSection = {
    iconClassName: TLazyIconKey;
    size: string | number;
    color: string;
  };

  // export type THours = {
  //   icon: TIconSection;
  //   text: string;
  //   hour: TDaywiseHours[];
  // };

  // export type TFacilityHours = {
  //   accordion: IAccordion;
  //   hours: THours[];
  // };

  export type TMedia = {
    video?: {
      src: string;
      alt: string;
    };
    imagesSrc?:
      | Array<{
          src: string;
          alt: string;
        }>
      | any;
    url?: any;
  };

  export type TButtonText = {
    icon: TIconSection;
    type: string;
    label: string;
    link: string;
  };
}
